import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import img from "../../../assets/images/contact-image.png";
import { Range, getTrackBackground } from "react-range";
import { Spring } from "react-spring/renderprops";
import "../../multi-step-components/SelectInsuranceOption";
import "./styles.scss";

const AbgBillSlider = ({ setStep, roofData, setRoofData }) => {
  const [values, setValues] = useState([roofData?.electricityBill || 100]);

  const handleContinueClick = () => {
    setRoofData({
      ...roofData,
      electricityBill: Number(values[0]),
    });
    setStep(3);
  };

  return (
    <>
      <Spring
        from={{ opacity: 0 }}
        to={{ opacity: 1 }}
        config={{ duration: 1500 }}
      >
        {(props) => (
          <Container style={props} className="multi-form-step-section">
            <span>
              {" "}
              <div>
                <img src={img} className="toast-image" alt="Helper Profile " />
              </div>
              <h5 className="insurance-header">
                {" "}
                What is Your Average Electric Bill?
              </h5>
            </span>
            <div>
              <div className=" range-section roof-selection-section">
                <div className="text-center">
                  <span className="currentValue"> ${values[0]} </span>{" "}
                </div>
                <div>
                  <Range
                    values={values}
                    step={50}
                    min={0}
                    max={400}
                    onChange={(v) => setValues([v])}
                    renderTrack={({ props, children }) => (
                      <div
                        style={{
                          ...props.style,
                          height: "36px",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div
                          ref={props.ref}
                          style={{
                            height: "16px",
                            width: "100%",
                            borderRadius: "100px",
                            background: getTrackBackground({
                              values: values,
                              colors: ["#fd832d", "#ffdece"],
                              min: 0,
                              max: 400,
                            }),
                            alignSelf: "center",
                          }}
                        >
                          {children}
                        </div>
                      </div>
                    )}
                    renderThumb={({ props, isDragged }) => (
                      <div
                        {...props}
                        style={{
                          ...props.style,
                          height: "30px",
                          width: "30px",
                          borderRadius: "100%",
                          backgroundColor: "#fd832d",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          boxShadow: "0px 2px 6px #AAA",
                        }}
                      ></div>
                    )}
                  />
                </div>
                <div className="range-Values">
                  <span className="text-left"> $0</span>
                  <span className="text-right"> $400</span>
                </div>
              </div>
            </div>
            <div
              style={{
                width: "90%",
              }}
              className="text-center mt-3 m-auto"
            >
              <button
                onClick={() => handleContinueClick()}
                className=" own-home-btn  sunroof-primary-btn m-auto btn-primary btn"
              >
                Continue
              </button>
            </div>
          </Container>
        )}
      </Spring>
    </>
  );
};

export default AbgBillSlider;
